import base from "../../../base";

const userIsBasic = async (uid) => {
	const basicUsers = await base.fetch(`basicUsers`, { context: this });
	if (Object.keys(basicUsers).includes(uid)) return true;
	return false;
};

export default userIsBasic;
